import { useEffect, useState } from 'react';
import { FaCheck, FaPen, FaTrash } from 'react-icons/fa';

import { createTeam, deleteTeam, getLeagues, getTeams, updateTeam } from '../api';
import { generateLeagueTheme } from '../utils/colorUtils';

function TeamsScreen() {
  const [teams, setTeams] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [newTeamName, setNewTeamName] = useState('');
  const [newTeamLeagueId, setNewTeamLeagueId] = useState('');
  const [editingTeam, setEditingTeam] = useState(null);

  useEffect(() => {
    fetchTeams();
    fetchLeagues();
  }, []);

  const fetchTeams = async () => {
    const response = await getTeams();
    setTeams(response.data);
  };

  const fetchLeagues = async () => {
    const response = await getLeagues();
    setLeagues(response.data);
    if (response.data.length > 0) {
      setNewTeamLeagueId(response.data[0].id);
    }
  };

  const handleCreateTeam = async (e) => {
    e.preventDefault();
    await createTeam({ name: newTeamName, league_id: newTeamLeagueId });
    setNewTeamName('');
    fetchTeams();
  };

  const handleUpdateTeam = async (id) => {
    await updateTeam(id, { name: editingTeam.name, league_id: editingTeam.league_id });
    setEditingTeam(null);
    fetchTeams();
  };

  const handleDeleteTeam = async (id) => {
    await deleteTeam(id);
    fetchTeams();
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2>Teams</h2>
      </div>

      <form onSubmit={handleCreateTeam}>
        <div className="form-group">
          <label htmlFor="team-name">Team Name</label>
          <input
            id="team-name"
            type="text"
            placeholder="Enter team name"
            value={newTeamName}
            onChange={(e) => setNewTeamName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="team-league">League</label>
          <div className="select-container">
            <select
              id="team-league"
              value={newTeamLeagueId}
              onChange={(e) => setNewTeamLeagueId(e.target.value)}
            >
              {leagues.map((league) => (
                <option key={league.id} value={league.id}>
                  {league.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button type="submit">Create Team</button>
      </form>

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>League</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {teams.map((team) => {
            const leagueName = team.league ? team.league.name : null;
            const themeColors = leagueName ? generateLeagueTheme(leagueName) : null;
            return (
            <tr
              key={team.id}
              className="league-row"
              style={themeColors ? {
                borderLeft: `4px solid ${themeColors.dark}`,
              } : {}}
            >
              <td>
                {editingTeam && editingTeam.id === team.id ? (
                  <input
                    type="text"
                    value={editingTeam.name}
                    onChange={(e) => setEditingTeam({ ...editingTeam, name: e.target.value })}
                  />
                ) : (
                  team.name
                )}
              </td>
              <td>
                {editingTeam && editingTeam.id === team.id ? (
                  <div className="select-container">
                    <select
                      value={editingTeam.league_id}
                      onChange={(e) => setEditingTeam({ ...editingTeam, league_id: e.target.value })}
                    >
                      {leagues.map((league) => (
                        <option key={league.id} value={league.id}>
                          {league.name}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : (
                  team.league ? team.league.name : 'N/A'
                )}
              </td>
              <td>
                <div className="table-actions">
                  {editingTeam && editingTeam.id === team.id ? (
                    <button onClick={() => handleUpdateTeam(team.id)} className="submit icon-btn"><FaCheck /></button>
                  ) : (
                    <button onClick={() => setEditingTeam({ ...team, league_id: team.league ? team.league.id : '' })} className="icon-btn"><FaPen /></button>
                  )}
                  <button onClick={() => handleDeleteTeam(team.id)} className="danger icon-btn"><FaTrash /></button>
                </div>
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default TeamsScreen;